import React, {useState} from 'react';
import {useTranslation} from "react-i18next";

import css from './SemiFinishedRightBlockModal.module.css';
import {RecipeForMultiform} from "../../../../ui/RecipeForMultiform/RecipeForMultiform";
import {SemiFinishedRightBlockInfoModal} from "../SemiFinishedRightBlockInfoModal/SemiFinishedRightBlockInfoModal";


const SemiFinishedRightBlockModal = ({selectedCategory, setSelectedCategory, handleCategoryChange}) => {
    const {t} = useTranslation();
    const [activeTab, setActiveTab] = useState("info");


    return (
        <div className={css.container}>
            <div className={css.tabs}>
                <button
                    className={activeTab === "info" ? css.activeTab : css.tab}
                    type={'button'}
                    onClick={() => setActiveTab("info")}
                >
                    {t('info')}
                </button>
                <button
                    className={activeTab === "recipe" ? css.activeTab : css.tab}
                    type={'button'}
                    onClick={() => setActiveTab("recipe")}
                >
                    {t('recipe')}
                </button>
            </div>

            <div className={css.infoBlock}>
                {activeTab === 'info' ? (
                    <div className={css.tabInfoBlock}>
                        <SemiFinishedRightBlockInfoModal
                            selectedCategory={selectedCategory}
                            setSelectedCategory={setSelectedCategory}
                            handleCategoryChange={handleCategoryChange}
                        />
                    </div>
                ) : (
                    <div className={css.recipeBlock}>
                        <RecipeForMultiform/>
                    </div>
                )}
            </div>
        </div>
    );
};

export {SemiFinishedRightBlockModal};